var en = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var number = function (value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error("Can't apply offset:" + offset + ' to argument `' + name + '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
};
var plural = function (value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
};
var select = function (value, data) {
  return {}.hasOwnProperty.call(data, value) ? data[value] : data.other;
};

module.exports = {
  generic: {
    results: function(d) { return plural(d.copy, 0, en, { "0": "0 Ergebnisse", "1": "1 Ergebnis", other: number(d.copy, "copy") + " Ergebnisse" }); }
  },
  search: {
    title: function(d) { return "Suchergebnisse"; },
    results: function(d) { return "„" + d.searchTerm + "“"; }
  },
  product: {
    notStockedOnLine: function(d) { return "Leider steht dieser Artikel ist nicht zum Verkauf."; },
    productCode: function(d) { return "Produktcode"; },
    soldOut: function(d) { return "Leider ist dieser Artikel aktuell nicht verfügbar. Speichern Sie diesen Artikel, damit Sie erfahren, wenn er wieder verfügbar ist."; },
    buyableFalse: function(d) { return "Leider steht dieser Artikel ist nicht zum Verkauf."; },
    unavailableProduct: function(d) { return "Leider steht dieser Artikel ist nicht zum Verkauf."; },
    shippingRestriction: function(d) { return "Leider steht dieser Artikel an Ihrem Standort nicht zum Verkauf."; },
    restrictedToEip: function(d) { return "Leider ist dieser Artikel aktuell nicht verfügbar. Beobachten Sie diesen Artikel auf Ihrer Wunschliste"; },
    doNotForgetToAddToWishlistMessage: function(d) { return "Vergessen Sie nicht, Ihren Artikel auf die Wunschliste zu setzen"; },
    shippingRestrictionsNotificationMessage: function(d) { return "Es können Versandbeschränkungen gelten [Mehr erfahren](/" + d.locale + "/content/help/delivery/)"; },
    needAdvice: function(d) { return "Benötigen Sie Rat?"; },
    needAdviceCTA: function(d) { return "Kundenservice kontaktieren"; },
    finalSaleNotification: function(d) { return "Final Sale - Dieser Artikel kann nicht zurückgegeben werden"; },
    genericMessage: function(d) { return ""; },
    Brand: function(d) { return "BRAND"; },
    Illustrative: function(d) { return "Beispiel"; },
    productTitle: function(d) { return "Titel des Artikels"; }
  },
  considered: {
    badge: function(d) { return "Nachhaltigkeit"; },
    consideredAccordion: function(d) { return "Wir sind stolz darauf, diesen Artikel als Teil unseres Engagements, unseren Kunden verantwortungsvolle Mode zugänglicher zu machen, in unser Nachhaltigkeits-Editorial aufzunehmen."; },
    actionText: function(d) { return "Mehr erfahren"; },
    href: function(d) { return "/editorial/our-considered-pledge"; },
    consideredAttributesTitle: function(d) { return "Was macht diesen Artikel „nachhaltig“?"; },
    consideredDelivery: function(d) { return "Dies ist die Lieferoption mit den derzeit geringsten CO2-Emissionen"; },
    consideredFilters: function(d) { return "Alle nachhaltigen Artikel ansehen"; }
  },
  colourAndSize: {
    colour: function(d) { return "Farbe"; },
    size: function(d) { return "Größe"; },
    button1: function(d) { return "Hallo"; },
    button2: function(d) { return "Hallo"; },
    line1: function(d) { return "Hallo"; },
    line2: function(d) { return "Hallo"; }
  },
  pagination: {
    first: function(d) { return "Anfang"; },
    previous: function(d) { return "Zurück"; },
    next: function(d) { return "Weiter"; },
    last: function(d) { return "Ende"; },
    status: function(d) { return "Seite " + d.currentPage + " von " + d.totalPages; }
  },
  contactUsCTA: {
    personalShopper: {
      title: function(d) { return "Lassen Sie sich von Ihrem Personal Shopping Team auf die Warteliste für diesen Artikel setzen"; },
      titleAssignedPS: function(d) { return "Lassen Sie sich von " + d.name + " auf die Warteliste für diesen Artikel setzen"; },
      emailLabel: function(d) { return "E-Mail"; },
      emailStructure: {
        subject: function(d) { return "Bitte setzen Sie mich auf die Warteliste für " + d.name; },
        body: function(d) { return "Lassen Sie sich von " + d.name + " auf die Warteliste für diesen Artikel setzen: " + d.url; }
      }
    },
    sizeAndFit: {
      title: function(d) { return "Still not sure what size to purchase?"; },
      titleEip: function(d) { return "Our Personal Shopping Team is on hand to provide detailed product information."; },
      titlePersonalShopper: function(d) { return "Your Personal Shopper is on hand to provide detailed product information."; },
      emailLabel: function(d) { return "Email"; },
      emailStructure: {
        subject: function(d) { return "I would like your advice for " + d.name; },
        body: function(d) { return "I am still not sure about sizing for this product: " + d.url; }
      }
    },
    badge: function(d) { return "PERSONAL SHOPPER KONTAKTIEREN"; },
    eip: {
      soldOutOnline: {
        title: function(d) { return "Kontaktieren Sie unser Personal Shopping Team, um eine Alternative zu finden"; },
        titleAssignedPS: function(d) { return "Kontaktieren Sie " + d.name + ", um eine Alternative zu finden"; },
        emailLabel: function(d) { return "E-Mail"; },
        emailStructure: {
          subject: function(d) { return "Ich suche nach Alternativen für " + d.name + " (ausverkauft)"; },
          body: function(d) { return "Ich benötige Hilfe bei der Suche nach Alternativen für diesen ausverkauften Artikel: " + d.url; }
        }
      },
      notStockedOnline: {
        title: function(d) { return "Kontaktieren Sie unser Personal Shopping Team, um diesen Artikel zu kaufen"; },
        titleAssignedPS: function(d) { return "Kontaktieren Sie " + d.name + ", um diesen Artikel zu kaufen"; },
        emailLabel: function(d) { return "E-Mail"; },
        emailStructure: {
          subject: function(d) { return "Ich würde gerne " + d.name + " kaufen"; },
          body: function(d) { return "Ich würde gerne diesen Artikel kaufen: " + d.url; }
        }
      },
      buyableFalse: {
        title: function(d) { return "Kontaktieren Sie unser Personal Shopping Team, um diesen Artikel zu kaufen"; },
        titleAssignedPS: function(d) { return "Kontaktieren Sie " + d.name + ", um diesen Artikel zu kaufen"; },
        emailLabel: function(d) { return "E-Mail"; },
        emailStructure: {
          subject: function(d) { return "Ich würde gerne " + d.name + " kaufen"; },
          body: function(d) { return "Ich würde gerne diesen Artikel kaufen: " + d.url; }
        }
      },
      shippingRestricted: {
        title: function(d) { return "Kontaktieren Sie unser Personal Shopping Team, um Hilfe beim Bestellabschluss zu erhalten."; },
        titleAssignedPS: function(d) { return "Kontaktieren Sie " + d.Name + ", um Hilfe beibeim Bestellabschluss zu erhalten."; },
        emailLabel: function(d) { return "E-Mail"; },
        emailStructure: {
          subject: function(d) { return "Bitte helfen Sie mir, eine Bestellung für " + d.name + " aufzugeben"; },
          body: function(d) { return "Bitte helfen Sie mir, eine Bestellung für diesen Artikel aufzugeben: " + d.url; }
        }
      },
      "default": {
        title: function(d) { return "Sie benötigen Hilfe bei der Größenauswahl, eine zweite Meinung oder können Ihre Größe nicht finden? Unser Personal Shopping Team hilft Ihnen gerne weiter"; },
        titleAssignedPS: function(d) { return "Sie benötigen Hilfe bei der Größenauswahl, eine zweite Meinung oder können Ihre Größe nicht finden? " + d.name + " hilft Ihnen gerne weiter."; },
        emailLabel: function(d) { return "E-Mail"; },
        emailStructure: {
          subject: function(d) { return "Ich benötige Ihre Hilfe, " + d.name; },
          body: function(d) { return "Ich benötige Ihre Hilfe: " + d.url; }
        }
      },
      badge: function(d) { return "PERSONAL SHOPPER KONTAKTIEREN"; }
    }
  },
  ctaButtons: {
    goToWishlist: function(d) { return "Zur Wunschliste"; },
    addToWishlist: function(d) { return "Zur Wunschliste hinzufügen"; },
    addToWishlistLoading: function(d) { return "Wird zur Wunschliste hinzugefügt ..."; },
    addToBag: function(d) { return "In den Warenkorb legen"; },
    goToBag: function(d) { return "Zum Warenkorb"; },
    addToBagLoading: function(d) { return "Wird in den Warenkorb gelegt ..."; },
    viewShoppingBag: function(d) { return "Warenkorb ansehen"; },
    viewMoreDetails: function(d) { return "Weitere Details ansehen"; }
  },
  price: {
    discountPercentage: function(d) { return "(-" + d.discountPercentage + "%)"; },
    discountPrice: function(d) { return "Reduzierung"; },
    currencyExchange: function(d) { return "(Ca. " + d.exchangeCurrency + " " + d.exchangePrice + ")"; },
    ddpInformation: function(d) { return "(taxes and duties included)"; },
    wasPriceOriginal: function(d) { return "UPE: " + d.wasPrice; },
    wasPrice: function(d) { return "UPE:"; },
    originalPrice: function(d) { return "Ursprünglicher Preis:"; },
    minimumPrice: function(d) { return "Niedrigster Preis in 30 Tagen"; },
    minimumPriceEqual: function(d) { return "Dies ist der niedrigste Preis in 30 Tagen"; },
    priceInformation: {
      title: function(d) { return "Informationen zur Preisgestaltung"; },
      subtitle: function(d) { return "Die Preisgestaltung bei THE OUTNET:"; },
      descriptionRRP: function(d) { return "**1. Aktueller Preis:**\nDer Preis, zu dem der Artikel exklusiv in der THE OUTNET-App und auf der Website angeboten wird\n\n**2. Niedrigster Preis in 30 Tagen:**\nDer niedrigste Preis, zu dem der Artikel in den letzten 30 Tagen angeboten wurde\n\n**3. Unverbindliche Preisempfehlung (UPE):**\nDer Preis, den der Hersteller als Verkaufspreis an die Kundschaft empfiehlt\n\n[Mehr erfahren](" + d.link + ")"; },
      descriptionOriginalPrice: function(d) { return "**1. Aktueller Preis:**\nDer Preis, zu dem der Artikel exklusiv in der THE OUTNET-App und auf der Website angeboten wird\n\n**2. Niedrigster Preis in 30 Tagen:**\nDer niedrigste Preis, zu dem der Artikel in den letzten 30 Tagen angeboten wurde\n\n**3. Ursprünglicher Preis:**\nDer Preis, zu dem der Artikel zum ersten Mal in der THE OUTNET-App und -Website gelistet wurde\n\n[Mehr erfahren](" + d.link + ")"; },
      descriptionRRPWithoutMinimumMessage: function(d) { return "**1. Aktueller Preis:**\nDer Preis, zu dem der Artikel exklusiv in der THE OUTNET-App und auf der Website angeboten wird\n\n**2. Unverbindliche Preisempfehlung (UPE):**\nDer Preis, den der Hersteller als Verkaufspreis an die Kundschaft empfiehlt\n\n[Mehr erfahren](" + d.link + ")"; },
      descriptionOriginalPriceWithoutMinimumMessage: function(d) { return "**1. Aktueller Preis:**\nDer Preis, zu dem der Artikel exklusiv in der THE OUTNET-App und auf der Website angeboten wird\n\n**2. Ursprünglicher Preis:**\nDer Preis, zu dem der Artikel zum ersten Mal in der THE OUTNET-App und -Website gelistet wurde\n\n[Mehr erfahren](" + d.link + ")"; }
    }
  },
  productListing: {
    unselectAll: function(d) { return "Alle entfernen"; },
    allSelected: function(d) { return "Alle"; },
    numberSelected: function(d) { return d.number + " ausgewählt"; },
    refine: function(d) { return "Filtern"; },
    priceFilter: {
      under: function(d) { return d.price; },
      over: function(d) { return d.price; }
    },
    apply: function(d) { return "Anwenden"; },
    clearFilters: function(d) { return "Filter löschen"; },
    sortBy: function(d) { return "Sortieren nach"; },
    topDesignersThisWeek: function(d) { return "Top-Designer dieser Woche"; },
    azDesigners: function(d) { return "Designer von A-Z"; },
    searchDesigner: function(d) { return "Designer durchsuchen"; },
    noResultsSearch: function(d) { return "We have found no results for \"" + d.searchTerm + "\". Please try again."; },
    emptyList: function(d) { return select(d.pageType, { MARK_DOWN: "Sale ist beendet", DESIGNER: "Die Artikel der neuen Saison treffen bald ein", SEARCH: "Wir haben keine Ergebnisse für " + d.query + " gefunden", other: "Keine Artikel gefunden" }); },
    emptyListCopy: function(d) { return select(d.pageType, { SEARCH: "Bitte probieren Sie einen anderen Suchbegriff oder durchstöbern Sie hier unten unsere Vorschläge", other: "" }); },
    emptyListGoTo: function(d) { return select(d.pageType, { other: "" }); },
    loadMore: function(d) { return "Mehr laden"; },
    youHaveViewed: function(d) { return "Sie haben " + d.totalNumberOfViewedProducts + " von " + d.totalProducts + " Artikeln angesehen"; },
    loadPrevious: function(d) { return "Vorherige laden"; },
    saleToggle: function(d) { return select(d.pageType, { DESIGNER: "Shop " + d.designerName + " Sale", other: "Shop all " + d.designerName }); },
    notifyTitle: function(d) { return "Oops!"; },
    continueLink: function(d) { return "Shop Just In"; },
    wishList: {
      title: function(d) { return "Auf die Wunschliste gesetzt"; },
      subtitle: function(d) { return "Sie können sich die vorgemerkten Artikel jederzeit in Ihrem Konto ansehen"; },
      goToWishlist: function(d) { return "Wunschliste öffnen"; }
    }
  },
  contentHeader: {
    viewMoreCopy: function(d) { return "Mehr"; },
    sale: function(d) { return "Sale"; }
  },
  collapsableContent: {
    viewMore: function(d) { return "more"; },
    viewLess: function(d) { return "less"; }
  },
  sizes: {
    sizeLabel: function(d) { return "Größe"; },
    oneSizeLabel: function(d) { return "Einheitsgröße"; },
    initialValue: function(d) { return "Größe auswählen"; },
    sizeConversion: function(d) { return "Eine " + d.sizeLabel + " entspricht einer " + d.localLanguageType + " " + d.localSizeValue; },
    sizeConversionModal: function(d) { return "Eine **" + d.sizeLabel + "** entspricht einer " + select(d.isSelected, { true: "**" + d.preferredSize + "**", other: d.preferredSize }); },
    sizeGuide: {
      viewProductMeasurements: function(d) { return "Größentabelle"; },
      viewSizeGuide: function(d) { return "Größentabelle"; },
      measuringGuide: function(d) { return "Maßenguide"; },
      title: function(d) { return "Größentabelle"; },
      sizeMeasurementsTitle: function(d) { return "Größenmaße"; },
      sizeMeasurementsDetails: function(d) { return "Alle Artikel werden von THE OUTNETs Größen- und Passformen-Team individuell vermessen."; },
      sizeConversionsTitle: function(d) { return "Informationen zur Größe"; },
      sizeConversionsDetails: function(d) { return "Sie wissen Ihre Größe nicht? Überprüfen Sie es hier."; },
      slideToScroll: function(d) { return "Zum Scrollen schieben"; },
      noFurtherInfo: function(d) { return "Keine weiteren Größenangaben"; },
      unavailable: function(d) { return "Nicht Verfügbar"; },
      cm: function(d) { return "cm"; },
      "in": function(d) { return "in"; },
      compareSize: {
        text: function(d) { return ""; },
        subText: function(d) { return ""; }
      },
      inStock: function(d) { return "Verfügbar"; },
      lowStock: function(d) { return "Nur noch wenige Artikel verfügbar"; },
      oneLeft: function(d) { return "Letztes Stück"; },
      outOfStock: function(d) { return "Ausverkauft"; }
    },
    watchSizeGuide: {
      title: function(d) { return ""; }
    }
  },
  seo: {
    azdesigners: {
      title: function(d) { return "Looks von Fashiondesignern shoppen | THE OUTNET"; },
      description: function(d) { return ""; },
      keywords: function(d) { return ""; }
    },
    pdpMarkup: {
      nbColours: function(d) { return plural(d.copy, 0, en, { "1": ", erhältlich in " + d.color1 + ".", "2": ", erhältlich in " + d.color1 + " oder " + d.color2 + ".", other: ", erhältlich in " + number(d.copy, "copy") + " Farben." }); },
      productDescription: function(d) { return d.name + " in " + d.color + ". Größe: " + d.size + ". " + select(d.material, { undefined: "", other: "Material: " + d.material + "." }); }
    },
    plpMarkup: {
      name: function(d) { return select(d.category, { undefined: d.designerName, other: d.category + " von " + d.designerName }); }
    }
  },
  error: {
    notFound: function(d) { return "Leider konnte diese Seite nicht gefunden werden."; },
    unknownError: function(d) { return "Etwas ist schief gelaufen."; },
    goBack: function(d) { return "Zurück"; }
  },
  retry: {
    title: function(d) { return "Leider ist diese Seite nicht verfügbar."; },
    retrynow: function(d) { return "Jetzt erneut versuchen"; },
    timetoretry: function(d) { return "In " + d.seconds + " Sekunden versuchen wir erneut, Sie zu verbinden ..."; },
    retryingnow: function(d) { return "Wird erneut versucht"; }
  },
  accordionTitles: {
    editorsNotes: function(d) { return "Editor‘s Notes"; },
    sizeAndFit: function(d) { return "Größe & Passform"; },
    technicalSpecification: function(d) { return "Technical Specification"; },
    detailsAndCare: function(d) { return "Details & Pflege"; },
    technicalDescription: function(d) { return "Details"; }
  },
  accordionIds: {
    editorsNotes: function(d) { return "EditorNotes"; },
    sizeAndFit: function(d) { return "SizeAndFit"; },
    detailsAndCare: function(d) { return "Details"; },
    technicalDescription: function(d) { return "DetailsAndCare"; }
  },
  sizeAndFit: {
    sizeDetails: function(d) { return select(d.slash, { slash: " / " + d.label + d.uom, other: d.label + d.uom }); }
  },
  detailsAndCare: {
    imported: function(d) { return "Dieser Artikel wurde importiert"; },
    madeIn: function(d) { return "Made in " + d.madeIn; }
  },
  notifications: {
    PAGE_NOT_AVAILABLE: {
      title: function(d) { return "Oops!"; },
      message: function(d) { return "We noticed you don't have the right permissions to access the sale, but don't worry, there's still lots of hidden gems to uncover in our new arrivals. While you wait, why not discover out latest arrivals?"; }
    },
    PAGE_CLOSED: {
      title: function(d) { return "Oops!"; },
      message: function(d) { return "We’re sorry, our sale has ended, but don’t worry there’s still lots of hidden gems to uncover in our new arrivals."; }
    },
    PAGE_SOON: {
      title: function(d) { return "Bright and early"; },
      message: function(d) { return "The early bird catches the worm, but you’re a little too early this time. While you wait, why not discover our latest arrivals? "; }
    },
    ADD_TO_BAG_MESSAGE_ERROR: function(d) { return "Artikel in den Warenkorb legen fehlgeschlagen"; },
    authToAdd: function(d) { return "Um diesen Artikel zu Ihrer Wunschliste hinzuzufügen, melden Sie sich bitte an oder registrieren Sie sich"; },
    promoPriceSuccess: function(d) { return "Aktionscode erfolgreich kopiert"; },
    errors: function(d) { return select(d.error, { ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR: " Bitte wählen Sie eine Größe.", ERR_WISH_LIST_NOT_EXISTS: " Diese Wunschliste wurde gelöscht. Setzen Sie diesen Artikel auf eine andere Wunschliste ", ERR_WISH_LIST_MAX_WISH_LIST_ITEMS_REACHED: " Sie haben die maximale Anzahl an Artikeln auf Ihrer Wunschliste erreicht. Nehmen Sie einige Artikel von Ihrer Wunschliste, um weitere Artikel hinzufügen zu können. ", ERR_SKU_ALREADY_EXISTS: " Dieser Artikel befindet sich bereits auf Ihrer Wunschliste.", NO_SIZE_SELECTED_ERROR: " Bitte wählen Sie eine Größe. ", TEMPORARY_ADD_TO_CART_ERROR: "Leider wurde dieser Artikel nicht zu Ihrem Warenkorb hinzugefügt. Bitte versuchen Sie es erneut. ", ADD_TO_CART_IDENTITY_GENERIC_ERROR: " Leider wurde dieser Artikel nicht zu Ihrem Warenkorb hinzugefügt. Bitte versuchen Sie es erneut. ", ADD_TO_CART_GENERIC_ERROR: " Leider wurde dieser Artikel nicht zu Ihrem Warenkorb hinzugefügt. Bitte versuchen Sie es erneut. ", CART_ITEM_OUT_OF_STOCK: "Leider ist dieser Artikel ausverkauft ", CART_ITEM_INSUFFICIENT_STOCK: " Leider ist dieser Artikel nicht mehr verfügbar ", CART_ORDER_LINE_QTY_LIMIT: "Leider haben Sie die maximale Anzahl an Artikeln in Ihrem Warenkorb erreicht.", CART_ORDER_LINES_LIMIT: "Wir haben Ihren Warenkorb aktualisiert, da wir nur eine bestimmte Anzahl der ausgewählten Artikel versenden können.", NO_UBER_TOKEN_ERROR: "", other: "Ihre Anfrage kann nicht ausgeführt werden. Bitte versuchen Sie es erneut." }); }
  },
  promoPrice: {
    codeDescription: function(d) { return "Code:"; },
    promotionalPrice: function(d) { return "Aktionspreis"; }
  },
  shopMore: {
    title: function(d) { return "Mehr ansehen"; }
  },
  wearItWith: {
    heading: function(d) { return "PERFEKT IN KOMBINATION MIT"; }
  },
  youMayAlsoLike: {
    heading: function(d) { return "Das könnte Ihnen auch gefallen"; }
  },
  soldOutReducedPage: {
    heading: function(d) { return "Ähnliche Artikel ansehen"; }
  },
  recentlyViewed: {
    heading: function(d) { return "Zuletzt angesehen"; }
  },
  moreByThisDesigner: {
    heading: function(d) { return "More By This Designer"; }
  },
  noResultsSearchPage: {
    dividerHeading: function(d) { return "Diese aktuell angesagten Artikel könnten Sie interessieren"; }
  },
  designers: {
    pageName: function(d) { return "Designer"; },
    favorite: function(d) { return "Favorite Designer"; },
    mens: function(d) { return "Herren"; },
    womens: function(d) { return "Damen"; }
  },
  designersWithSale: {
    pageName: function(d) { return "Designer Sale"; }
  },
  deliveryAndReturns: {
    title: function(d) { return "Versand & Rückgaben"; },
    description: function(d) { return "Erfahren Sie mehr über unsere Versandoptionen und wie Sie Artikel umtauschen oder zurücksenden können."; },
    shippingModesIntro: function(d) { return "Hier sind Ihre Versandoptionen:"; },
    shippingMode: function(d) { return select(d.shipModeCode, { STANDARD: " Standard ", EXPRESS: " Express ", NEXT_DAY_DELIVERY: " Next dayag ", PREMIER_DAYTIME: " Premier DayTime ", PREMIER_EVENING: " Premier Evening ", other: "" }); },
    returnsInfo: function(d) { return "Sie können Ihre Artikel ganz einfach umtauschen oder zurücksenden, stellen Sie nur sicher, dass Sie sie innerhalb von 28 Tagen zurückschicken."; },
    findOutMoreLink: function(d) { return "Mehr erfahren"; }
  },
  errors: {
    empty: function(d) { return "Dieses Feld ist erforderlich"; },
    invalid: function(d) { return "Gültigen Wert für " + d.field + " eingeben"; }
  },
  accountUtility: {
    signupMessage: function(d) { return "\nAbonnieren Sie unsere E-Mails, um über zukünftige Sales und weitere Veranstaltungen informiert zu werden."; },
    submit: function(d) { return "Abschicken"; },
    emailLabel: function(d) { return "E-Mail-Adresse"; }
  },
  recommendations: {
    viewSimilarItems: function(d) { return "Mehr ansehen"; }
  },
  manufacturerDetails: {
    title: function(d) { return "Details zur Herstellung"; },
    subtitle: function(d) { return "HERSTELLERINFORMATIONEN"; },
    button: function(d) { return "Details zur Herstellung ansehen"; },
    content: function(d) { return "Zu diesem Artikel liegen uns derzeit keine Informationen vor, aber wir bemühen uns, diese baldmöglichst zu ergänzen.\n\nWir danken für Ihr Verständnis und für Ihre Geduld."; }
  }
}